import React from 'react'

export default function Timeline({
  fileList = [],
  currentFile,
  width,
  setProgress
}) {

  const boxWidth = 80
  const years = React.useMemo( () => [...new Set(fileList.map(i => i.year))], [fileList])
  const activeYear = currentFile ? currentFile.year : 2020
  const pos = currentFile ? years.indexOf(currentFile.year) : 0

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        right: -pos * boxWidth,
        display: 'flex',
        flexDirection: 'row-reverse',
        width: years.length * boxWidth,
        height: 40,
        // transition: 'right 0.1s',
        boxSizing: 'content-box',
        padding: `0 ${width / 2 - 40}px`
      }}
    >
      {years.map((y, i) => (
        <div
          key={y}
          onClick={() =>
            setProgress(
              i / years.length
            )
          }
          style={{
            fontSize: '1.2rem',
            lineHeight: 1,
            width: boxWidth,
            textAlign: 'center',
            color: activeYear === y ? '#fff' : '#666',
          }}
        >
          {y}
        </div>
      ))}
    </div>
  )
}
